export const environment = {
  production: false,
  BASE_URL: "https://sigmatconfluxdevapi.sigmat.in/api/",
  API_BASE_URL: "sigmatconfluxdevapi.sigmat.in",
  NAME: "dev environment",
  saveUrl: "",
  path: "",
  imageBaseUrl: "https://sigmatconfluxdevapi.sigmat.in/uploads/",
  firebaseConfig: {
    apiKey: "AIzaSyAABWVHcf0TTRvkcDpmhw9pAgFFRlgUteY",
    authDomain: "clif-.firebaseapp.com",
    projectId: "clif-864a1",
    storageBucket: "clif-.firebasestorage.app",
    messagingSenderId: "275052466574",
    appId: "1:275052466574:web:aa2752b7634990818b54df",
  },
  mapboxToken:
    "pk.eyJ1IjoiZXhhbXBsZXVzZXIiLCJhIjoiY2t2eHBzYXN2dHgzbzJ2b3A0YmlzaDRkZCJ9.TG8An3-some-valid-token-string",
  geoserverWmsUrl: "",
  geoserverWfsUrl: "",
  cadViewerServerUrl: "",
  cadViewerServerBackEndUrl: "",
  cadViewerServerLocation: "",
};
